import React, { useEffect } from 'react';
import * as breakpoint from '../../styles/breakpoints.module.scss';
import { getImage, withArtDirection } from "gatsby-plugin-image"
import { useLocalization } from "gatsby-theme-i18n";
import PageHeadline from '../../components/PageHeadline';
import Seo from "../../components/SEO"
import { RecipeBlock } from "../../components/RecipeList"
import { graphql } from 'gatsby';

import MoreActivitySection from "../../sections/common/MoreActivitySection";
import CrosssiteBannerSection from '../../sections/common/CrosssiteBannerSection';
import IntroductionSection from '../../sections/eorzeacafe-at-home/IntroductionSection';
import CommonSection from "../../components/CommonSection";

const EorzeacafeAtHome = ({ data }) => {
  const { t, addString, localeKey } = useLocalization();

  useEffect(() => {
    addString('eorzeacafe_at_home',data.allActivitiesEorzeacafeAtHomeCsv.nodes)
  },[addString,data]);


  return (<div>
    <Seo 
        title={data.pageTitle[localeKey]} 
        description={data.pageDescription[localeKey]}  />  
    <PageHeadline 
      category={t('eorzeacafe_at_home.page.category.label')} 
      title={t('eorzeacafe_at_home.page.display.title')} 
      subtitle={t('eorzeacafe_at_home.page.display.description')}
      bgImg={
        withArtDirection(getImage(data.headlineBg), [
          {
            media: `(min-width: ${breakpoint.mdMin})`,
            image: getImage(data.headlineBg),
          },
          {
            media: `(max-width: ${breakpoint.smMax}) and (min-width: ${breakpoint.smMin})`,
            image: getImage(data.headlineBg_tablet),
          },
          {
            media: `(max-width: ${breakpoint.xsMax})`,
            image: getImage(data.headlineBg_mobile),
          }
        ])}/>
      <IntroductionSection list={data.recipeList.edges}/>
      <CommonSection>
        {data.recipeList.edges.map((item,index) => <RecipeBlock data={item.node.childMdx} key={`recipe_${index}`} />)}
      </CommonSection>

    <MoreActivitySection currentPage={"eorzeacafe_at_home"}/>
    <CrosssiteBannerSection />
  </div>);
}
 
export default EorzeacafeAtHome;

export const query = graphql`
  query ActivitiesEorzeacafeAtHomePageQuery($localePath: String!) {
    pageTitle : activitiesEorzeacafeAtHomeCsv(key: {regex: "/^page.title/"}) {
      ...localizedContent
    }
    pageDescription : activitiesEorzeacafeAtHomeCsv(key: {regex: "/^page.description/"}) {
      ...localizedContent
    }

    allActivitiesEorzeacafeAtHomeCsv {
      nodes {
        ...localizedContent
      }
    }
    headlineBg : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/EorzeacafeAtHome/bg_pageHeader.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    headlineBg_tablet : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/EorzeacafeAtHome/bg_pageHeader_tablet.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    headlineBg_mobile : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/EorzeacafeAtHome/bg_pageHeader_mobile.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }

    

    recipeList :allFile(
      filter: {
        sourceInstanceName: {eq: "recipe"}, 
        childrenMarkdownRemark: {
          elemMatch: {
            fields: {
              localePath: {eq: $localePath}
            }
          }
        }
      },
      sort: {fields: childrenMarkdownRemark___frontmatter___num, order: ASC}
    ) {
      edges {
        node {
          childMdx {
            frontmatter {
              title
              slug
              num
              movie_url
              job {
                level
              }
              item_level
              introduction
              embed_url
              eyecatch {
                childImageSharp {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: NONE
                  )
                }
              }
              ingredients {
                annotation
                name
                value
              }
            }
            body
          }
        }
      }
    }
    
    
  }
`
